import * as React from 'react'

import { TextAlign } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import TextField from 'modules/core/components/TextField'
import { get12HFormat, get24HFormat } from 'modules/core/lib/formatTime'

import Text from 'modules/core/components/Inputs/Text'
import type { TextProps } from 'modules/core/components/Inputs/types'
import State, { getDefaultString } from './polyfill/State'
import polyfillOnClick from './polyfill/onClick'
import polyfillOnKeyDown from './polyfill/onKeyDown'

type Props = TextProps & {
  isTimeFormat24H?: boolean
  hideError?: boolean
  isNotValid?: boolean
  placeholder?: string
  hideBorder?: boolean
  textAlign?: TextAlign
  autofocus?: boolean
}

const TimePicker = (props: Props) => {
  const [inputState, setInputState] = React.useState<State | null | undefined>(null)
  const [input, setInput] = React.useState<HTMLInputElement | null | undefined>(null)
  const isTimeFormat24H: boolean = props.isTimeFormat24H ?? true

  const onClick = () => {
    if (inputState) polyfillOnClick(inputState)
  }

  const onKeyDown = (e: React.KeyboardEvent) => {
    if (inputState) polyfillOnKeyDown(inputState, e)

    if (props.onKeyDown) props.onKeyDown(e)
  }

  const onFocus = (e: React.FocusEvent<HTMLInputElement, Element>) => {
    //Added e.target to support autofocus attribute
    if (input || e.target) {
      setInputState(new State(input || e.target, isTimeFormat24H))
    }

    if (props.onFocus) props.onFocus(e)
  }

  const onBlur = (e: React.FocusEvent<HTMLInputElement, Element>) => {
    setInputState(null)

    if (props.onBlur) props.onBlur(e)
  }

  const getInputRef = (input: HTMLInputElement | null | undefined) => {
    if (input) setInput(input)
  }

  const onChange = (value: string) => {
    if (isTimeFormat24H) return props.field.set(value)

    props.field.set(get24HFormat(value))
  }

  const isMobile = (): boolean => {
    if (!window.matchMedia) return false

    return window.matchMedia('only screen and (max-width: 768px)').matches
  }

  const getValue = () => {
    if (!isTimeFormat24H) return get12HFormat(props.field.value)

    return props.field.value
  }

  const getError = () => {
    if (!props.field.errors) return undefined

    return props.field.errors[0]
  }

  return (
    <>
      {isMobile() && ( // HACK: Show type='time' to mobile users
        <Text
          type="time"
          label={props.label}
          mandatory={props.mandatory}
          readonly={props.readonly}
          field={props.field}
          error={getError()}
          attachmentPosition={props.attachmentPosition}
        />
      )}
      {!isMobile() && (
        <TextField
          label={props.label}
          mandatory={props.mandatory}
          readonly={props.readonly}
          onKeyDown={onKeyDown}
          onClick={onClick}
          getRef={getInputRef}
          onFocus={onFocus}
          onBlur={onBlur}
          placeholder={props.placeholder || getDefaultString(isTimeFormat24H)}
          onChange={onChange}
          value={getValue()}
          error={getError()}
          ariaHidden
          hideError={props.hideError}
          isNotValid={props.isNotValid}
          focused={props.focused}
          attachmentPosition={props.attachmentPosition}
          hideBorder={props.hideBorder}
          textAlign={props.textAlign}
          autofocus={props.autofocus}
        />
      )}
    </>
  )
}

export default observer(TimePicker)
